module.exports = __webpack_public_path__ + "img/ic_24_social_facebook.9ebcd245.svg";